import { Action } from 'helpers/action-helpers';
import { Guid } from 'types/guid';
import { Notification } from 'types/notification';

export const LIST_NOTIFICATIONS = 'ListNotificationsAction';
export const SET_NOTIFICATIONS = 'SetNotificationsAction';
export const DISMISS_NOTIFICATION = 'DismissNotificationAction';

export class ListNotificationsAction extends Action {
  constructor(public tenantId: Guid, public username: string) {
    super(LIST_NOTIFICATIONS);
  }
}

export class SetNotificationsAction extends Action {
  constructor(public notifications: Notification[]) {
    super(SET_NOTIFICATIONS);
  }
}

export class DismissNotificationAction extends Action {
  constructor(public notificationId: Guid) {
    super(DISMISS_NOTIFICATION);
  }
}


// WEBPACK FOOTER //
// ./src/components/notification/actions.ts